import { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';

function CustomMapControl({ map, position, children }) {
  const controlDiv = useRef(document.createElement('div'));

  useEffect(() => {
    if (!map) return;

    const div = controlDiv.current;

    // Add the control to the map
    map.controls[position].push(div);

    return () => {
      // Remove the control when unmounting
      const index = map.controls[position].getArray().indexOf(div);
      if (index > -1) {
        map.controls[position].removeAt(index);
      }
    };
  }, [map, position]);

  return createPortal(children, controlDiv.current);
}

export default CustomMapControl;
